var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveSystemSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4587 0.041687H2.54199C1.16128 0.041687 0.0419922 1.16098 0.0419922 2.54169V17.4584C0.0419922 18.8391 1.16128 19.9584 2.54199 19.9584H17.4587C18.8394 19.9584 19.9587 18.8391 19.9587 17.4584V2.54169C19.9587 1.16098 18.8394 0.041687 17.4587 0.041687ZM5.00049 2H16.8522C17.4864 2 18.0005 2.51412 18.0005 3.14833V5H5.00049V2ZM5.00049 6H18.0005V8H5.00049V6ZM5.00049 9H18.0005V11H5.00049V9ZM5.00049 12H18.0005V14H5.00049V12ZM5.00049 15H18.0005V16.8517C18.0005 17.4859 17.4864 18 16.8522 18H5.00049V15ZM4.00049 14.5V11.5V8.5V5.5V2H3.14881C2.51461 2 2.00049 2.51412 2.00049 3.14833V16.8517C2.00049 17.4859 2.51461 18 3.14881 18H4.00049V14.5Z",
    fill: "#FFFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSystemSummary);
export default __webpack_public_path__ + "static/media/activeSystemSummary.961bf438d1a268f3d7a9fab5e791e105.svg";
export { ForwardRef as ReactComponent };